import { PlaceholdersId, TFComponent } from '@types';

import { PaymentOptionsPlaceholder } from './paymentOptions';

export const paymentOptions: TFComponent = {
	component: PaymentOptionsPlaceholder,
	id: PlaceholdersId.paymentOptions,
	name: 'paymentOptions',
};
